import { render } from "./StudentClass.vue?vue&type=template&id=b9a38c10&scoped=true"
import script from "./StudentClass.vue?vue&type=script&lang=js"
export * from "./StudentClass.vue?vue&type=script&lang=js"

import "./StudentClass.vue?vue&type=style&index=0&id=b9a38c10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a38c10"]])

export default __exports__